<template>
  <div>
    <b-form @submit.prevent="handleSubmit">
      <b-row class="d-md-block">
        <b-col>
          <InputText
            v-model="email"
            :errors="errorsFields.email.concat(emailRepeatedCheck)"
            :placeholder="$t('profile.signUp.main.email')"
            @blur="startCheckingEmail"
            @change="validateEmail"
          />
        </b-col>
      </b-row>
      <b-row class="d-md-block">
        <b-col>
          <InputText
            v-model="password"
            :errors="errorsFields.password"
            type="password"
            autocomplete="current-password"
            :placeholder="$t('profile.signUp.main.password')"
            @change="validatePassword"
          />
        </b-col>
      </b-row>
      <div class="my-2 min-h-19">
        <recaptcha />
      </div>
      <div class="mt-3 small">
        <Button
          width="full"
          color="gray-800"
          text="white"
          :style="{
            '--custom-radius': '8px',
            '--custom-font-size': '14px'
          }"
          :submit="true"
        >
          {{ $t('profile.signUp.main.title') }}
        </Button>
      </div>
    </b-form>
    <div v-if="error">
      <div v-if="typeof errorMessage === 'string'">
        <ErrorSection :error-message="errorMessage" />
      </div>
      <div v-else>
        <div v-for="(message, index) in errorMessage" :key="index">
          <ErrorSection :error-message="message" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import InputText from 'UI/InputText';
import Button from 'UI/Button';
import ErrorSection from '@/components/User/Form/ErrorSection';
import { validateEmail } from '~/utils/common.js';
export default {
  components: {
    InputText,
    Button,
    ErrorSection
  },
  data() {
    return {
      error: false,
      errorMessage: '',
      errorsFields: {
        email: [],
        password: []
      },
      checkingEmail: false,
      email: '',
      password: ''
    };
  },
  computed: {
    ...mapState('user', ['isEmailChecking']),
    isEmailOk() {
      return this.$store.getters['user/isEmailAvailable'](this.email);
    },
    emailRepeatedCheck() {
      if (!this.isEmailChecking && !this.isEmailOk && this.checkingEmail) {
        return [this.$t('profile.signUp.main.emailInUse')];
      } else {
        return [];
      }
    },
    emailIsNotRepeated() {
      return !this.isEmailChecking && this.isEmailOk;
    }
  },
  methods: {
    requiredValidation(value) {
      return value.length;
    },
    validateEmail() {
      const value = this.email;
      this.checkEmail();
      const isEmailValid = validateEmail(this.email);
      const requiredFeedback = this.requiredValidation(value)
        ? ''
        : this.$t('profile.logIn.main.emailIsRequired');
      const emailFeedback = isEmailValid ? '' : this.$t('profile.signUp.main.emailMustBeValid');
      this.errorsFields.email = [requiredFeedback ? requiredFeedback : emailFeedback].filter(
        (value) => value
      );
      return this.errorsFields.email;
    },
    validatePassword() {
      this.errorsFields.password = [
        this.requiredValidation(this.password)
          ? ''
          : this.$t('profile.logIn.main.passwordIsRequired')
      ].filter((value) => value);
      return this.errorsFields.password;
    },
    validateFields() {
      return [...this.validateEmail(), ...this.validatePassword()].filter((value) => value);
    },
    handleSubmit() {
      if (!this.validateFields().length) {
        this.localSignup();
      }
    },
    startCheckingEmail() {
      this.checkingEmail = true;
      this.checkEmail();
    },
    checkEmail() {
      if (this.checkingEmail) {
        this.$store.dispatch('user/CHECK_EMAIL_AVAILABILITY', this.email);
      }
    },
    async localSignup() {
      this.$emit('loading', true);
      await this.signUpUser();
      this.$emit('loading', false);
    },
    async signUpUser() {
      if (!this.emailIsNotRepeated) {
        this.error = true;
        this.errorMessage = this.$t('profile.signUp.main.emailNotAvailable');
      } else {
        try {
          const captchaToken = await this.$recaptcha.getResponse();
          const response = await this.$store.dispatch('user/SIGN_UP', {
            email: this.email,
            password: this.password,
            captchaToken
          });
          if (!response.error) {
            this.$emit('signup');
            await this.$store.dispatch('auth/loadUser', {
              token: response.token,
              strategy: 'local'
            });
            this.$emit('login');
            this.$bvModal.show('profiling-modal');
          } else {
            this.error = true;
            this.errorMessage = [];
            for (let i = 0; i < response.data.length; i++) {
              let res = `${this.$t(`${response.data[i].code}`)} ${
                response.data[i].data ? `: min. ${response.data[i].data}` : ''
              }`;
              this.errorMessage.push(res);
            }
          }

          try {
            await this.$recaptcha.reset();
          } catch (error) {
            console.error('SIGN UP', error);
          }
        } catch (error) {
          this.error = true;
          this.errorMessage = this.$t('profile.signUp.main.error');
          console.error('SIGN UP', error);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.min-h-19 {
  min-height: 4.75rem;
}
</style>
